import { createFileRoute, redirect } from "@tanstack/react-router";

import { pickEnum, pickString } from "@/lib/search-params";

import {
  ADMIN_OFFER_CLICK_RANGES,
  type AdminOfferClickRange,
} from "./-admin-offer-click-analytics-query";

interface AdminOfferClickSearch {
  q?: string;
  range: AdminOfferClickRange;
}

/**
 * Old bookmarks land on the analytics tab with their search and range. Their `provider` held a
 * store display name, which the stream's `store` filter (a provider key) cannot match, so it is dropped.
 */
export const Route = createFileRoute("/_app/admin/offer-clicks/")({
  validateSearch: (raw: Record<string, unknown>): AdminOfferClickSearch => ({
    q: pickString(raw.q),
    range: pickEnum(raw.range, ADMIN_OFFER_CLICK_RANGES) ?? "24h",
  }),
  beforeLoad: ({ search }) => {
    throw redirect({
      to: "/admin",
      search: { q: search.q, range: search.range, tab: "offer-clicks" },
      replace: true,
    });
  },
});
